<template>
  <vx-card no-shadow>
     <vx-form class="md:w-1/2" layout="v" label-align="top" v-slot="{invalid, handleSubmit}">
      <form-item label="联系人" rules="required">
        <vs-input class="w-full" placeholder="请输入联系人" v-model="form.name" />
      </form-item>
      <form-item required label="手机号">
        <vs-input class="w-full" placeholder="请输入手机号" v-model="form.phone" />
      </form-item>
      <form-item required label="收货地址">
        <vs-input class="w-full" v-model="form.address" />
      </form-item>
      <form-item label="微信号">
        <vs-input class="w-full" v-model="form.wxh" />
      </form-item>
      <form-item label="QQ">
        <vs-input class="w-full" v-model="form.qq" />
      </form-item>
      <form-item>
        <vs-button v-if="nextStep" :disabled="invalid" class="mr-3 mb-2" @click="handleSubmit(submitFormAndStep)">下一步</vs-button>
        <vs-button v-else :disabled="invalid" class="mr-3 mb-2" @click="handleSubmit(submitForm)">保存设置</vs-button>
      </form-item>
     </vx-form>
  </vx-card>
</template>
<script>
export default {
  props: {
    nextStep: Function,
  },
  data() {
    return {
      form: {}
    }
  },
  async mounted() {
    const contact = await this.$s.user.getContact()
    this.form = {
      ...contact
    }
  },
  methods: {
    async submitForm() {
      const data = {
        ...this.form,
      }
      await this.$s.user.updateContact(data)
      this.$notify({
        title: "成功更新联系信息"
      })
      this.$s.user.getContact()
    },
    async submitFormAndStep() {
      await this.submitForm()
      this.nextStep()
    }
  }
}
</script>